<script>
    import {onMount} from 'svelte';
    import Chart from 'chart.js';
    import Common from '../public/lib/common';
    import 'chartjs-plugin-labels';


    let labelsData;
    let valuesData;
    let titleData;
    let colorsData;

    const colorsPalette = {
        colors7: ["#ef8b46", "#f3ac71", "#f6c785", "#f8db94", "#895881", "#a17a94", "#c6a9b5"],
        colors4: ["#ffcf01", "#f8991d", "#f36c36", "#e81e26"],
        colors2: ["#00aeef", "#e81e25"]
    };


    let outer = Common.randomString();
    let inner = Common.randomString();

    let getColorsData = () => {
        if (colorsData) {
            return colorsData;
        }
        switch (labelsData.length) {
            case 7:
                return colorsPalette.colors7;
            case 4:
                return colorsPalette.colors4;
            case 2:
                return colorsPalette.colors2;
        }

        return colorsPalette.colors7;
    };

    export function setup (data) {

        labelsData = data.labelsData;
        valuesData = data.valuesData;
        titleData = data.titleData;
        colorsData = data.colorsData;

        let w = jQuery('#' + outer).width();
        jQuery('#' + outer).css({'height': w / 2 + 'px'});

        jQuery('#' + inner).css({'width': w + 'px'});
        jQuery('#' + inner).css({'height': w / 2 - 10 + 'px'});

        let borderColorData = Array(labelsData.length).fill("#d1d1d1");

        var chartCtx = jQuery("#" + inner).get(0).getContext("2d");
        new Chart(chartCtx, {
            type: 'doughnut',
            data: {
                labels: labelsData,
                datasets: [
                    {
                        label: "",
                        backgroundColor: getColorsData(),
                        borderColor: borderColorData,
                        data: valuesData
                    }
                ]
            },
            options: {
                responsive: true,
                legend: {
                    labels: {
                        fontColor: "#fff"
                    }
                },
                title: {
                    display: true,
                    fontSize: 18,
                    fontColor: '#fff',
                    text: titleData
                },
                plugins: {
                    labels: {
                        // render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage'
                        render: 'percentage',
                        overlap: false,
                        fontColor: '#fff',
                        fontSize: 16
                    }
                }
            }
        });
    }

</script>

<main class="chart-container" id="{outer}">
    <canvas id="{inner}">
    </canvas>
</main>

<style>

</style>
